/* eslint-disable no-console,no-unused-vars,no-undef */
import React from 'react';
import TableGridHeader from './TableGridHeader';
import NikeReactTable from './NikeReactTable';
import Scroll from 'react-scroll';
import { ReactTableDefaults } from 'react-table';
import {connect} from "react-redux";
import {
    createSelectedPDF,
    createAllPDF,
    cacheRowIDs,
    uncacheRowIDs,
    loadDataFromAPI,
    cacheSearchResults,
    cacheStatus
} from '../APIs/dataHelper';
import {checkForToken, login} from "../APIs/loginHelper";
import {setUserNameAction} from '../Actions/userInfo';
import {
    setTablePageIndexAction,
    setTablePageSizeAction,
    setTablePageOffsetAction,
    setNewSearchAction,
    setDataCachedAction
} from '../Actions/data';
import {setLoadingIndicator} from "../Actions/loading";
import {errorCodeLibrary} from '../APIs/errorCodes';
import {setErrorState} from "../Actions/errorHandler";

export class TableGridContainer extends React.Component  {
    constructor(props) {
        super(props);
        this.instance = null;
        this.manual = true;

        this.state = {
            canGeneratePDF  : false,
            totalRowCount   : 0,
            data            : [],
            loading         : false,
            pages           : 0,
            page            : 0,
            pageSize        : 100,
            resultCnt       : undefined,
            isNewSearch     : false,
            isCacheCallSend : false
        };
    }

    componentDidMount() {

        const jwt = checkForToken ();
        if (!jwt || !jwt.accessToken) {
            //redirect to SSO if detects query string has been entered and no jwt present
            console.log("NO JWT");
            login ();
        }
        else {
            this.props.setUserNameAction(jwt.username);
        }
    }

    async cacheStatusCheck() {
        await cacheStatus(this.props.filters, this.props.userInfo.userName, this.props.userInfo.searchTimestamp, 1, 0)
            .then((res) =>{
                if(res.data == 'Cached'){
                    this.props.setDataCachedAction(true);
                }
            }).catch( (err) => {
                console.log(err);
                this.props.setDataCachedAction(false);
                this.props.setErrorState( err, errorCodeLibrary.cacheDataErrorCodes[err] ? errorCodeLibrary.cacheDataErrorCodes[err] : errorCodeLibrary.cacheDataErrorCodes.default);
            });
    }


    async componentDidUpdate(prevProps) {
        if (prevProps.userInfo.searchTimestamp !== this.props.userInfo.searchTimestamp && this.instance !== null && this.manual) {
            this.setState({
                page        : 0,
                isNewSearch : true

            });
            this.onFetchData(this.instance.state, null, true);

            await cacheSearchResults(this.props.filters, this.props.userInfo.userName, this.props.userInfo.searchTimestamp, 5)
                .then((res) =>{
                    if(res === 200)
                    {
                        this.setState({
                            isCacheCallSend : true
                        });
                    }
                }).catch( (err) => {
                    console.log(err);
                    this.props.setDataCachedAction(false);
                    this.props.setErrorState( err, errorCodeLibrary.cacheDataErrorCodes[err] ? errorCodeLibrary.cacheDataErrorCodes[err] : errorCodeLibrary.cacheDataErrorCodes.default);
                });
            if(this.state.isCacheCallSend)
                await this.cacheStatusCheck();
        }
    }
    async cacheIds(username, timestamp, ids, retries) {
        await cacheRowIDs(username, timestamp, ids, retries);
    }

    async uncacheIds(username, timestamp, ids, retries) {
        await uncacheRowIDs(username, timestamp, ids, retries);
    }

    getData(page, pageSize, sorted, firstSearch) {
        return new Promise ((resolve, reject) => {
            resolve(loadDataFromAPI(this.props.filters, this.props.userInfo.userName, this.props.userInfo.searchTimestamp, pageSize, (page * pageSize), firstSearch, 5));
        });
    }


    getInfoText(totalResults = this.state.resultCnt) {
        let recordsInfoText = "No records";
        if (!this.instance) {
            return recordsInfoText;
        }

        if (totalResults) {
            const { pageSize, page } = this.instance.state;
            const lastPage = ((page + 1) * pageSize) > totalResults;
            const recordsCountFrom = (page * pageSize) + 1;
            const recordsCountTo = (!lastPage ? ((page + 1) * pageSize) : totalResults);
            recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalResults} records`;
        }

        return recordsInfoText;
    }

    async onFetchData({page, pageSize, sorted }, instance, firstSearch=false) {
        if (!this.instance && instance) {
            this.instance = instance;
            // Don't trigger a search when setting up the instance
            return;
        } else if ((!this.instance && !instance) || !this.props.userInfo.searchTimestamp) {
            // Don't trigger a search if no instance OR search cache ID hasn't been set in Redux.
            return;
        } else if (page !== this.instance.state.page) {
            return;
        }

        this.setState({
            dataLoading : true,
            dataLoaded  : false
        });
        //this.props.setDataLoadingAction(true);
        try {
            if(firstSearch)
                this.props.setLoadingIndicator(true);
            const data = await this.getData(page, pageSize, sorted, firstSearch)
                .catch((err) => {this.props.setErrorState(err, errorCodeLibrary.searchErrorCodes[err] ? errorCodeLibrary.searchErrorCodes[err] : errorCodeLibrary.searchErrorCodes.default);});
            const totalResults = data.totalRowCount;
            this.props.setLoadingIndicator(false);
            this.setState({
                data        : data.searchRequest,
                resultCnt   : totalResults,
                pages       : Math.ceil(totalResults / pageSize),
                dataLoading : false,
                dataLoaded  : true,
                isNewSearch : false
            });
            this.props.setLoadingIndicator(false);
            //this.props.setDataCachedAction(false);
        } catch (e) {
            // There was an error in the API call being made.
            console.error(e);
            this.setState({
                data        : [],
                dataLoading : false,
                isNewSearch : false
            });
            this.props.setDataCachedAction(false);
        }
    }

    render()
    {
        const columns =[
            {
                Header   : 'TEST REQUEST SEASON',
                accessor : 'testSubmissionCycleYear',
                width    : 150
            },
            {
                Header   : 'TEST REQUEST ID',
                accessor : 'testRequestIdentifier',
                width    : 150
            },
            {
                Header   : 'PCX SUPPLIED MATERIAL NUMBER',
                accessor : 'suppliedMaterialIdentifier',
                width    : 200
            },
            {
                Header   : 'PPS ITEM NUMBER',
                accessor : 'nikePPSItemNumber',
                width    : 150
            },
            {
                Header   : 'TEST TYPE',
                accessor : 'testSubmissionType',
                width    : 100
            },
            {
                Header   : 'MATERIAL TYPE',
                accessor : 'materialType',
                width    : 100
            },
            {
                Header   : 'END USE',
                accessor : 'nikeMsEndUse',
                width    : 100
            },
            {
                Header   : 'SPECIFICATION',
                accessor : 'testSpecificationName',
                width    : 100
            },
            {
                Header   : 'LAB TEST STATUS',
                accessor : 'testSubmissionStatusIndicator',
                width    : 100
            },
            {
                Header   : 'LAB TEST STATE',
                accessor : 'labTestState',
                width    : 100
            },
            {
                Header   : 'SUBMIT SM DESCRIPTION',
                accessor : 'testSubmissionSuppliedMaterialDescription',
                width    : 480
            },
            {
                Header   : 'SUPPLIED MATERIAL DESCRIPTION',
                accessor : 'nikeMsMaterialItemDescription',
                width    : 480
            },
            {
                Header   : 'LAB RECEIVED DATE',
                accessor : 'testSubmissionReceivedDate',
                width    : 200
            },
            {
                Header   : 'OUT OF LAB DATE',
                accessor : 'testResultCompletedDate',
                width    : 200
            },
            {
                Header   : 'SUBMIT FAILURE SUMMARY',
                accessor : 'testResultFailureSummary',
                width    : 200
            },
            {
                Header   : 'SUPPLIED MATERIAL COLOR',
                accessor : 'suppliedMaterialColorName',
                width    : 200
            },
            {
                Header   : 'SUPPLIER LOCATION',
                accessor : 'nikeSupplierLocation',
                width    : 150
            },
            {
                Header   : 'NIKE LIAISON OFFICE',
                accessor : 'responsibleNLO',
                width    : 120
            },
            {
                Header   : 'LAB',
                accessor : 'testLabIdentifier',
                width    : 100
            },
            {
                Header   : 'TEST RESULTS COMMENTS',
                accessor : 'testResultComments',
                width    : 240
            }
        ];

        return (
            <Scroll.Element name={this.props.name} id={this.props.name}>
                <div className="tableGrid-container">
                    <TableGridHeader resultCnt={this.state.resultCnt} title={this.props.title} canGeneratePDF={this.state.canGeneratePDF} dataCached={this.props.dataCached}/>
                    <NikeReactTable
                        name="results"
                        data={this.state.data} // The row data
                        manual={this.manual}
                        loading={this.state.dataLoading}
                        id="id" // The unique identifier in the data for each row
                        style={{height : (window.innerHeight-200) + 'px'}}
                        pages={this.state.pages}
                        defaultPageSize={100}
                        checkboxAt={0} // Where to place the checkbox column
                        onCheckChange={(arr, changed) => {
                            if(changed.checked) {
                                this.cacheIds(this.props.userInfo.userName, this.props.userInfo.searchTimestamp, changed.changed, 5)
                                    .catch((err => {
                                        this.props.setErrorState(err.response.status, errorCodeLibrary.cacheDataErrorCodes[err.response.status] ? errorCodeLibrary.cacheDataErrorCodes[err.response.status] : errorCodeLibrary.cacheDataErrorCodes.default);
                                    }));
                            }
                            else {
                                if(!this.state.isNewSearch) {
                                    this.uncacheIds(this.props.userInfo.userName, this.props.userInfo.searchTimestamp, changed.changed, 5)
                                        .catch((err => {
                                            this.props.setErrorState(err.response.status, errorCodeLibrary.cacheRowErrorCodes[err.response.status] ? errorCodeLibrary.cacheRowErrorCodes[err.response.status] : errorCodeLibrary.cacheRowErrorCodes.default);
                                        }));
                                }
                            }
                            if(arr.length > 0 ) {
                                this.setState({canGeneratePDF : true});
                            }
                            else {
                                this.setState({canGeneratePDF : false});
                            }
                        }}
                        sortable={false}
                        minRows={10}
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                        selectAllType="page" // If set to "page" only the current page rows will be checked
                        columns={columns}
                        className="-striped"
                        onFetchData={this.onFetchData.bind(this)}
                        onPageChange={(idx) => {
                            this.setState({page : idx});
                        }}
                        PaginationComponent={(props) => {
                            const PaginationComponent = ReactTableDefaults.PaginationComponent;
                            return (
                                <div>
                                    <PaginationComponent {...props} />
                                    <div>
                                        <span className={`nike-react-footer-text`}>{this.getInfoText()}</span>
                                    </div>
                                </div>
                            );
                        }}
                        shouldClearSelected={this.state.isNewSearch}
                    />
                </div>
            </Scroll.Element>
        );}
}

const mapStateToProps = (state) => {
    return {
        filters          : state.filters,
        userInfo         : state.userInfo,
        data             : state.data,
        loadingIndicator : state.loadingIndicator,
        errorHandler     : state.errorHandler

    };
};
const mapDispatchToProps = {
    createSelectedPDF,
    createAllPDF,
    cacheRowIDs,
    uncacheRowIDs,
    setUserNameAction,
    setTablePageIndexAction,
    setTablePageOffsetAction,
    setTablePageSizeAction,
    setNewSearchAction,
    setDataCachedAction,
    setLoadingIndicator,
    setErrorState
};
export default connect( mapStateToProps,mapDispatchToProps)(TableGridContainer);



// WEBPACK FOOTER //
// ./src/Components/TableGridContainer.js